import script from "./stockAllocationViewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./stockAllocationViewModal.vue?vue&type=script&setup=true&lang=js"

import "./stockAllocationViewModal.vue?vue&type=style&index=0&id=49e059de&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49e059de"]])

export default __exports__